import { Box, ButtonBase } from "@mui/material"
import schemeTokens from "./tokens"

const SchemeTabs = ({ value, options, onChange, counts = {} }) => (
  <Box
    role="radiogroup"
    aria-label="Scheme status"
    sx={{
      display: "flex",
      p: "4px",
      gap: "2px",
      bgcolor: schemeTokens.color.trackBg,
      borderRadius: schemeTokens.radius.control,
      overflowX: "auto",
    }}
  >
    {options.map((option) => {
      const selected = option.value === value
      const count = counts[option.value]
      return (
        <ButtonBase
          key={option.value}
          role="radio"
          aria-checked={selected}
          onClick={() => onChange(option.value)}
          sx={{
            flex: 1,
            minWidth: "fit-content",
            px: 1.75,
            py: 1,
            whiteSpace: "nowrap",
            borderRadius: schemeTokens.radius.control,
            fontSize: 13.5,
            fontWeight: 600,
            color: selected ? "text.primary" : "text.secondary",
            bgcolor: selected ? schemeTokens.color.surface : "transparent",
            boxShadow: selected ? 1 : "none",
            transition: "all .14s ease",
          }}
        >
          {count ? `${option.label} (${count})` : option.label}
        </ButtonBase>
      )
    })}
  </Box>
)

export default SchemeTabs
